import { isNullOrUndefined, mergeDeep, setDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { isOccurrenceOrChildOfOccurrenceKey, isRepeatingOrHasRepeatingChild } from './occurrence';
/***
Returns module data for a field group referred to by valueKey
Includes all data from top level group as well as specific occurrences
Example:
  moduleData = {
    "group": [
      {
        "group2": [
          { "foo": "bar" },
          { "foo": "baz" }
        ],
        "text": "hey"
      }
    ]
  }
 i.e. buildGroupValue(moduleData, ["group", 0, "group2", 1]) =>
  {
    "group": {
      "group2": { "foo": "baz" },
      "text": "hey"
    }
  }
***/
export function buildGroupValue(searchObject, valueKey) {
  if (!Array.isArray(valueKey) || !searchObject) {
    return undefined;
  }
  if (!valueKey.length || typeof searchObject !== 'object') {
    return searchObject;
  }
  const key = valueKey[0];
  const value = searchObject[key];
  if (isNullOrUndefined(value)) {
    return searchObject;
  }
  if (typeof key === 'number') {
    return buildGroupValue(value, valueKey.slice(1));
  } else if (typeof key === 'string') {
    return Object.assign({}, searchObject, {
      [key]: buildGroupValue(value, valueKey.slice(1))
    });
  }
  return searchObject;
}
export function getGroupValueFromKey(groupValue, valueKey) {
  if (!Array.isArray(valueKey) || !groupValue) {
    return undefined;
  }
  if (!valueKey.length || typeof groupValue !== 'object') {
    return groupValue;
  }
  const key = valueKey[0];
  if (typeof key === 'number') {
    return getGroupValueFromKey(groupValue, valueKey.slice(1));
  }
  if (isNullOrUndefined(groupValue[key])) {
    return undefined;
  }
  if (typeof key === 'string') {
    return getGroupValueFromKey(groupValue[key], valueKey.slice(1));
  }
  return groupValue;
}
export function getGroupValue(fields, fieldKey, module, options = {}) {
  const {
    maintainOccurrenceArrays
  } = options;
  let currentField = null;
  let groupValue = null;
  fieldKey.forEach((keyItem, index) => {
    const currentFieldKey = fieldKey.slice(0, index + 1);
    if (typeof keyItem === 'string') {
      if (currentField && currentField.children) {
        currentField = currentField.children.find(_field => _field.name === keyItem);
      } else if (!currentField) {
        currentField = fields.find(_field => _field.name === keyItem);
      }
      if (currentField && currentField.type === FieldTypes.GROUP && !isNullOrUndefined(currentField.default)) {
        // We want to make sure that parent group defaults override the current group's default
        // setDeepValue will override existing values, so that's why we setDeepValue and then
        // mergeDeep back into the existing values to favor existing values
        const groupOrModuleData = groupValue || module;
        groupValue = mergeDeep(setDeepValue(groupOrModuleData, currentFieldKey, currentField.default), groupOrModuleData);
      }
    }
    // If we're on a specific index of a repeater, use the values at that index rather than
    // the occurrence array (unless maintainOccurrenceArrays is true - we want to use the
    // array when setting an occurrence value for the first time so that there's an array to
    // set the value on top of)
    if (!maintainOccurrenceArrays && groupValue && (isRepeatingOrHasRepeatingChild(currentField) || isOccurrenceOrChildOfOccurrenceKey(currentFieldKey))) {
      groupValue = buildGroupValue(groupValue, currentFieldKey);
    }
  });
  return groupValue;
}